module.exports = __webpack_public_path__ + "static/shape-15fd2efc2b4a168c2f799ce5578b8c55.png";